mod.modules.define("SecurityBanner", "BaseModule", function(fn) {

	var cache = {
		$bars: null
	};

	fn.prototype.init = function(params) {
		this.wsodIssue = params.wsodIssue || "";

		// Cache
		cache.$bars = this.el.find("ul.security-bars");

		// Find the watchlist modals
		this.$modalWatchlistAddIssue = $("#addToWatchlistSearchModal");
		this.$modalWatchlistCreate = $("#createWatchlistModal");

		// Make the temp container and add the modals to it
		this.$container = $("<div id='WatchlistModalContainer' />").append(
			this.$modalWatchlistAddIssue,
			this.$modalWatchlistCreate
		).appendTo("body");

		this.WatchlistPlugin = mod.modules.create("WatchlistModals", this.$container);

		// Add the rolodex feature
		cache.$bars.rolodex({
			direction: "top",
			scrollSpeed: 250
		});

		this.initTooltips();
		//this.initModals();
	};

	fn.prototype.dispose = function(removeFromDom) {
		this.base("dispose", removeFromDom);

		this.$container.remove();
	};

	// Attach modals to the body so z-indexing works and bind events
	fn.prototype.initModals = function() {
		var self = this;
		var wlmodal = this.el.find("div.watchlistModal");

		if (wlmodal.length > 0) {
			$("button", wlmodal).on("click", function(e) {
				var action = $(this).data("action");
				if (action == "cancel") {
					self.WatchlistPlugin.closeModal(wlmodal);
				} else if (action == "create-new-watchlist") {
					self.WatchlistPlugin.createNewWatchlist();
					self.reload();
				} else if (action == "addIssue") {
					self.WatchlistPlugin.addIssue();
				}
			});

			wlmodal.detach().appendTo($("body"));
		}
	};

	fn.prototype.observables = {
		"my notepad updated": function() {
			this.reload();
		}
	};

	fn.prototype.initTooltips = function () {
		this.el.find("a.tooltip-trigger").tooltip({ html: true, maxWidth: 340 });

	};

	fn.prototype.events = {
		// Scroll the banner
		".scroll-chiclet:not(.disabled)": {
			"click": function(e, $el) {
				// Scroll to the new index
				var index = parseInt($el.attr("data-index"));
				cache.$bars.rolodex("to", index);

				// Highlight this chiclet
				$el.siblings().removeClass("selected");
				$el.addClass("selected");
			}
		},
		// View/Add notes, view reports
		".module-expand": {
			"click": function(e, $el) {
				var newSize = 4;
				var type = $el.attr("data-type");
				var newId = mod.modules.getKeyFromTypeSize(type, newSize);
				var context = $el.attr("data-context");

				if (context) {
					context = JSON.parse(context) || {};
				}

				this.handle_moduleExpand(newId, context);
			}
		},
		// Go to watchlist
		"#actionmenu-watchlists a": {
			"click": function(e, $el) {
				var watchlistID = $el.attr("data-watchlist-id");
				this.WatchlistPlugin.goHome(watchlistID);
			}
		},
		// Add to watchlist
		"div.security-banner-desc button[data-action]": {
			"click": function(e, $el) {
				var action = $el.data("action");

				if (action == "addToWatchlist") {
					var count = $el.data("watchlistcount");
					var $modalContent = (count > 0) ? this.$modalWatchlistAddIssue : this.$modalWatchlistCreate;
					this.WatchlistPlugin.wsodIssue = $el.data("current-wsodissue");
					this.WatchlistPlugin.showModal($modalContent, this.$container);
				}
			}
		}
	};

});